// Calendly integration helper — lazy-loaded on demand for performance.
// The Calendly widget script (~50KB) is only fetched when the user actually opens the booking modal.
const CALENDLY_URL = "https://calendly.com/l-kroeber/exclusive-property-call";

let calendlyLoadPromise = null;

const loadCalendly = () => {
  if (calendlyLoadPromise) return calendlyLoadPromise;
  calendlyLoadPromise = new Promise((resolve, reject) => {
    // Inject the stylesheet
    if (!document.querySelector('link[href*="calendly.com/assets/external/widget.css"]')) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://assets.calendly.com/assets/external/widget.css";
      document.head.appendChild(link);
    }
    // Inject the script
    if (window.Calendly) { resolve(window.Calendly); return; }
    const existing = document.querySelector('script[src*="calendly.com/assets/external/widget.js"]');
    if (existing) {
      existing.addEventListener("load", () => resolve(window.Calendly));
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    script.onload = () => resolve(window.Calendly);
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return calendlyLoadPromise;
};

export async function openCalendly() {
  try {
    await loadCalendly();
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: CALENDLY_URL });
      return;
    }
  } catch (e) {
    // fall through to new-tab fallback
  }
  window.open(CALENDLY_URL, "_blank");
}

// Prefetch Calendly on mouseover/first user interaction — small UX boost
let prewarmed = false;
export function prefetchCalendly() {
  if (prewarmed) return;
  prewarmed = true;
  // Use requestIdleCallback if available so we don't compete with critical work
  const start = () => { loadCalendly().catch(() => { /* ignore */ }); };
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(start, { timeout: 4000 });
  } else {
    setTimeout(start, 2500);
  }
}

export default CALENDLY_URL;
